import FindAllClient from "@/v2/api/client/FindAll";
import ArFormCombobox from "../form/ComboBoxFormField";
import { Client } from "@/v2/types";
import { FieldValues, Path } from "react-hook-form";

export function ClientComboBox<T extends FieldValues>({
    name,
    storeFullObject = false,
    setSelectedClient,
    disabled = false,
    defaultValue,
}: {
    name: Path<T>;
    storeFullObject?: boolean;
    setSelectedClient?: (value: Client | null) => void;
    disabled?: boolean;
    defaultValue: Client | null;
}) {
    return (
        <ArFormCombobox<T, Client>
            name={name}
            defaultValue={defaultValue}
            disabled={disabled}
            label="Select Client"
            queryKey="clients"
            queryFn={async ({ pageParam, search, limit }) =>
                FindAllClient({
                    skip: pageParam,
                    limit,
                    search,
                })
            }
            getDisplayValue={(client) => client.full_name}
            renderItem={(client) => (
                <div className="flex flex-col">
                    <span>{client.full_name}</span>
                    {client.short_code && (
                        <span className="text-xs text-muted-foreground">
                            {client.short_code}
                        </span>
                    )}
                </div>
            )}
            placeholder="Select client..."
            width="w-full"
            storeFullObject={storeFullObject}
            onItemSelect={(client: Client | null) => {
                setSelectedClient && setSelectedClient(client);
            }}
        />
    );
}
